import { sliceArrayPerChunk } from '../../../../../utils';


const categoryTabs = document.querySelectorAll('[data-category-tab-item]');
const categoryTabContent = document.querySelectorAll('[data-category-tab-content]');
const categorySelect = document.querySelector('[data-category-select]');
const moreButtom = document.querySelector('[data-samples-more-btn]');


/**
 *  Select Tabs
 */
export class SelectTabs {
  clear = () => {
    [].slice.call(categoryTabContent).forEach((content) => {
      content.classList.remove('active-content');
    });
  };

  change = (e) => {
    this.clear();
    const getCategory = e.currentTarget.options[categorySelect.selectedIndex].value;
    document.querySelector(`[data-category-tab-content="${getCategory}"]`).classList.add('active-content');
  };

  init = () => categorySelect.addEventListener('change', this.change, false);
}


/**
 * Tabs
 */
export class Tabs {
  constructor() {
    this.state = {
      currentIndex: 0,
    };
  }

  clear = () => {
    [].slice.call(categoryTabs).forEach((tab) => {
      tab.classList.remove('active-tab');
      const getTabCategory = tab.getAttribute('data-category-tab-item');
      document.querySelector(`[data-category-tab-content="${getTabCategory}"]`).classList.remove('active-content');
    });

    this.state.currentIndex = 0;
  };

  getActiveCategory = () => document.querySelector('.active-content').getAttribute('data-category-tab-content');

  getActiveContent = () => document.querySelector(`[data-category-tab-content="${this.getActiveCategory()}"]`);

  getActiveContentSamples = () => this.getActiveContent().querySelectorAll('.Sample');

  getActiveSamplesLength = () => this.getActiveContent().querySelectorAll('.show-sample').length;

  firstRun = () => {
    if (this.state.currentIndex === 0) {
      [].slice.call(this.getActiveContentSamples()).forEach(sample => sample.classList.remove('show-sample'));

      const slicedSamplesArr = sliceArrayPerChunk([].slice.call(this.getActiveContentSamples()), 3);
      slicedSamplesArr[0].forEach(sample => sample.classList.add('show-sample'));
    }
  };

  handleMoreBtn = () => {
    const activeSampleLength = this.getActiveSamplesLength();
    const contentsSample = this.getActiveContentSamples();
    const contentsSampleLength = contentsSample.length;
    const slicedSamplesArr = sliceArrayPerChunk([].slice.call(contentsSample), 3);

    if (
      contentsSampleLength > activeSampleLength
      && contentsSampleLength > 3
      && contentsSampleLength - activeSampleLength >= 1
    ) {
      slicedSamplesArr[this.state.currentIndex].forEach(sample => sample.classList.add('show-sample'));
      this.state.currentIndex += 1;

      moreButtom.classList.add('show-btn');
    } else {
      moreButtom.classList.remove('show-btn');
    }

    if (contentsSampleLength === this.getActiveSamplesLength()) {
      moreButtom.classList.remove('show-btn');
    }
  };

  change = (e) => {
    this.clear();

    e.target.classList.add('active-tab');
    const getTabCategory = e.currentTarget.getAttribute('data-category-tab-item');
    document.querySelector(`[data-category-tab-content="${getTabCategory}"]`).classList.add('active-content');

    this.firstRun();
    this.handleMoreBtn();
  };

  init = () => {
    [].slice.call(categoryTabs).forEach((tab) => {
      tab.addEventListener('click', this.change, false);
    });

    this.firstRun();
    this.handleMoreBtn();

    moreButtom.addEventListener('click', () => {
      this.handleMoreBtn();
    }, false);
  };
}


/**
 * ShowMore - for pages like a /law/cases.html
 */
export class ShowMore {
  constructor() {
    this.state = {
      currentIndex: 0,
    };
  }

  getItemsBlock = () => document.querySelector('[data-samples-items]');

  getActiveContentSamples = () => this.getItemsBlock().querySelectorAll('.Sample');

  getActiveSamplesLength = () => this.getItemsBlock().querySelectorAll('.show-sample').length;

  firstRun = () => {
    const slicedSamplesArr = sliceArrayPerChunk([].slice.call(this.getActiveContentSamples()), 3);
    slicedSamplesArr[0].forEach(sample => sample.classList.add('show-sample'));
  };

  handleMoreBtn = () => {
    const activeSampleLength = this.getActiveSamplesLength();
    const contentsSample = this.getActiveContentSamples();
    const contentsSampleLength = contentsSample.length;
    const slicedSamplesArr = sliceArrayPerChunk([].slice.call(contentsSample), 3);

    if (
      contentsSampleLength > activeSampleLength
      && contentsSampleLength > 3
      && contentsSampleLength - activeSampleLength >= 1
    ) {
      slicedSamplesArr[this.state.currentIndex].forEach(sample => sample.classList.add('show-sample'));
      this.state.currentIndex += 1;

      moreButtom.classList.add('show-btn');
    } else {
      moreButtom.classList.remove('show-btn');
    }

    if (contentsSampleLength === this.getActiveSamplesLength()) {
      moreButtom.classList.remove('show-btn');
    }
  };

  init = () => {
    this.firstRun();
    this.handleMoreBtn();

    moreButtom.addEventListener('click', () => {
      this.handleMoreBtn();
    }, false);
  };
}
